import axios, { Axios } from 'axios'
import Deferred from 'promise-deferred'

const accessKey = process.env.VUE_APP_UNSPLASH_ACCESS_KEY || ''

const UNSPLASH_CLIENT = axios.create({
  baseURL: 'https://api.unsplash.com/',
  headers: { Authorization: `Client-ID ${accessKey}` },
})

const PROXY_CLIENT = axios.create({
  baseURL: 'https://pr.laborx.com/unsplash/',
  headers: { Authorization: `Client-ID ${accessKey}` },
})

UNSPLASH_CLIENT.interceptors.response.use((resp) => resp.data)
PROXY_CLIENT.interceptors.response.use((resp) => resp.data)

interface UnsplashImage {
  alt_description: string
  urls: {
    raw: string
    ful: string
    small: string
  }
}

interface UnsplashResponse {
  results: Array<UnsplashImage>
  total_pages: number
}

class Unsplash {
  client: Axios
  initPromise: Deferred.Deferred<boolean> | null = null
  inited: boolean = false

  constructor() {
    this.client = UNSPLASH_CLIENT
    this.initPromise = new Deferred()
  }

  async initClient(keyword: string) {
    if (this.inited) {
      return
    }
    try {
      await this.search({ keyword })
    } catch (e) {
      this.client = PROXY_CLIENT
    } finally {
      this.initPromise?.resolve(true)
      this.initPromise = null
      this.inited = true
    }
  }

  /**
   * Get a single page of photo results for a query
   * https://unsplash.com/documentation#search-photos
   * @param {String} keyword Search terms
   * @returns {Object} unsplash response
   */
  async search({
    keyword,
    page = 1,
    limit = 16,
    orientation = 'landscape',
  }: {
    keyword: string
    page?: number
    limit?: number
    orientation?: string
  }) {
    const result = await this.client.get('/search/photos', {
      params: {
        query: keyword,
        per_page: limit,
        page,
        orientation,
      },
    })
    return result
  }
}

export default new Unsplash()
